/**
 * ContactCommsTab — the "Communications" TAB on a Contact record (Person lens).
 *
 * P3 MERGED LENS (2026-07-09): a THIN wrapper over the shared <LensThread/>.
 * It shows this person's WhatsApp (List A — the live `wa_conversations` store,
 * the same source as the Team Inbox) MERGED with their internal notes + email
 * (List B — `projects/{vp}/messages`), in the REAL Team-Inbox <Thread/>. One
 * source per channel, one chronological thread — it cannot drift from the inbox.
 *
 * Send paths preserved: WhatsApp via the real <Composer/> (24h window, ⚡ 📋 📎
 * 😀); internal notes + email via the Thread's channel switcher. Email is NO
 * LONGER missing — the old "coming to this view next" note is gone.
 *
 * SCROLL: the `.panel-wrap.is-comms-pane` viewport-lock (see ContactCommsTab.css
 * + ClientDetail's `--rec-comms-top`) bounds this pane; `.cct-root` is
 * `flex:1; min-height:0`, so the reused `.ti-canvas` is the SOLE scroller.
 */
import LensThread from '../features/teaminbox/lens/LensThread';
import './ContactCommsTab.css';

/** A project this contact is on — kept for call-site compatibility. */
export interface ContactProjectRef {
  pid: string;
  /** display label, e.g. "VP123". */
  label: string;
}

interface ContactCommsTabProps {
  contactId: string;
  /** Contact display name — shown in the header + empty copy. */
  contactName?: string;
  /** The contact's primary project — the note/email send target. */
  primaryProjectId?: string;
  /** Retained for call-site compatibility (describes the contact's project spread). */
  projects?: ContactProjectRef[];
}

export default function ContactCommsTab({
  contactId,
  contactName,
  primaryProjectId,
}: ContactCommsTabProps) {
  return (
    <div className="cct-root">
      <div className="cct-head">
        <h3 className="cct-title">Communications</h3>
      </div>
      <p className="cct-sub">
        The live WhatsApp thread, email and internal notes with this person — the
        same sources as the Team Inbox, filtered to them and merged newest-last.
        Replies, templates and the 24-hour window are live here.
      </p>
      <LensThread
        mode="contact"
        contactId={contactId}
        contactName={contactName}
        primaryProjectId={primaryProjectId}
      />
    </div>
  );
}
